/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Edit Action Icon
 *
 * @file EditActionIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropType from 'prop-types';

const EditActionIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.65 0C9.67173 0 10.5 0.828273 10.5 1.85L10.494 2H15.125C15.6082 2 16 2.39175 16 2.875C16 3.35825 15.6082 3.75 15.125 3.75H15V15.5C15 16.8807 13.8807 18 12.5 18H3.5C2.11929 18 1 16.8807 1 15.5V3.75H0.875C0.391751 3.75 0 3.35825 0 2.875C0 2.39175 0.391751 2 0.875 2H5.50599C5.50202 1.95052 5.5 1.9005 5.5 1.85C5.5 0.828273 6.32827 0 7.35 0H8.65ZM13.25 3.75H2.75V15.5C2.75 15.9142 3.08579 16.25 3.5 16.25H12.5C12.9142 16.25 13.25 15.9142 13.25 15.5V3.75ZM6 6V13.5C6 14.0523 5.55228 14.5 5 14.5C4.44772 14.5 4 14.0523 4 13.5V6H6ZM9 6V13.5C9 14.0523 8.55229 14.5 8 14.5C7.44772 14.5 7 14.0523 7 13.5V6H9ZM12 6V13.5C12 14.0523 11.5523 14.5 11 14.5C10.4477 14.5 10 14.0523 10 13.5V6H12Z" fill="currentColor" />
  </SvgIcon>
);

EditActionIcon.propTypes = {
  className: PropType.string.isRequired
};

export default EditActionIcon;

